import { Component, ChangeDetectionStrategy,} from '@angular/core';
import {
  NzModalRef,
  NzMessageService,
  NzModalService, NzUploadFile,
} from 'ng-zorro-antd';
import { HttpClient, HttpRequest, HttpResponse} from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { DynamicComponentImportFormService } from './service/dynamic-component-import-form.service';
@Component({
  selector: 'lc-import-form',
  templateUrl: './lc-import-form.component.html',
  providers: [ DynamicComponentImportFormService ]
})
export class LcImportFormComponent {
  /**
   * 窗体id
   */
  windowFormId: string;
  uploading = false;
  fileList: NzUploadFile[] = [];
  uploadFile: any;

  constructor(
      private http: HttpClient,
      private msg: NzMessageService,
      private modal: NzModalRef,
      private modalService: NzModalService,
      private service: DynamicComponentImportFormService
  ) {
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.concat(file);
    this.uploadFile = file;
    return false;
  };

  handleUpload(): void {
    const formData = new FormData();
    formData.append('file', this.uploadFile);
    formData.append('windowFormId',this.windowFormId);
    this.uploading = true;
    const req = new HttpRequest('POST', 'metabase/dynamicComponentImportForm/importExcel', formData, {
      // reportProgress: true
    });
    this.http
        .request(req)
        .pipe(filter(e => e instanceof HttpResponse))
        .subscribe(
            (e: HttpResponse<Response>) => {
              console.log(e);
              this.uploading = false;
              this.fileList = [];
              const body:any=e.body;
              if (body.code === 1) {
                this.msg.success('导入成功');
                this.closeOnClick();
              } else {
                this.modalService.error({
                  nzTitle: 'error',
                  nzContent: body.message,
                });
              }
            },
            e => {
              console.log(e);
              this.uploading = false;
              this.msg.error('upload failed.');
            },
        );
  }
  closeOnClick() {
    this.modal.close();
  }
  download() {
    this.service.downloadTemplate("windowFormId="+this.windowFormId);
  }
}
